module.exports = __webpack_public_path__ + "static/img/form_demo_2.66f5b2a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/form_demo_2.png
// module id = ofN9
// module chunks = 1